import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const mfaCheckmarkIcon = svgToTinyDataUri(
  `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_14202_89044)">
<path d="M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM10.5 1.90909C5.75537 1.90909 1.90909 5.75537 1.90909 10.5C1.90909 15.2446 5.75537 19.0909 10.5 19.0909C15.2446 19.0909 19.0909 15.2446 19.0909 10.5C19.0909 5.75537 15.2446 1.90909 10.5 1.90909ZM15.1569 6.9614C15.5297 6.58862 16.1341 6.58862 16.5069 6.9614C16.8796 7.33417 16.8796 7.93856 16.5069 8.31133L9.54545 15.2727C9.17268 15.6455 8.5683 15.6455 8.19552 15.2727L5.05231 12.1295C4.67953 11.7567 4.67953 11.1524 5.05231 10.7796C5.42508 10.4068 6.02946 10.4068 6.40224 10.7796L8.87049 13.2478L15.1569 6.9614Z" fill="#501283"/>
</g>
<defs>
<clipPath id="clip0_14202_89044">
<rect width="21" height="21" fill="white"/>
</clipPath>
</defs>
</svg>`
);
